export const status_array = [
  "PENDING ARRIVAL",
  "CONFIRMED",
  "IN LOBBY",
  "IN ROOM",
  "SEEN",
  "NO SHOW",
  "CANCELLED",
];

export const confirm_status_array = ["Not Confirmed", "Confirmed"];

export const CHARGE_ENTRY_TABS_LIMIT = 5;

// LOGIN GROUPS
export const PROVIDER_PORTAL_SCRIBE_GROUP = "ProviderPortalScribeGroup";
export const PATIENT_BALANCE_DASHBOARD = "ProviderPortalAdminGroup";
export const PROVIDER_PORTAL_ADMIN_GROUP = "ProviderPortalAdminGroup";
export const PROVIDER_PORTAL_ANSWERING_SERVICE_GROUP =
  "ProviderPortalAnsweringServiceGroup";
export const BILLING_PORTAL_ADMIN_GROUP = "BillingPortalAdminGroup";
export const CLINICAL_CARE_QUALITY_GROUP = "ClinicalCareQualityGroup";
export const USER_MANAGER_ADMIN_GROUP = "CHANGE_LATER_TO_ADMIN";
